<template>
  <div>
    <BlBannerMv 
      v-if="!getRetryOtpToggle"
      class="qa-dont-share-otp-section mb-12"
    >
      Jangan kasih kode kamu ke siapa pun termasuk pihak yang mengaku dari Bukalapak.
    </BlBannerMv>
    <BlTextAv variation="body-14" class="mb-20">
      Masukkan Kode Verifikasi yang telah dikirim via SMS ke <span class="font-medium">{{ $root.phoneNumber }}</span>
    </BlTextAv>

    <BlTextAv variation="caption-12">Kode Verifikasi</BlTextAv>

    <center class="mv-12">
      <BlCodeInputMv 
        v-model="otp" 
        :length="6" 
        :class="otpInputClass" />
    </center>

    <BlTextAv v-if="isOtpError" class="qa-otp-error-msg" color="error-01" variation="body-14">Kode verifikasi tidak sesuai, cek kembali ya.</BlTextAv>

    <BlBannerMv v-if="getRetryOtpToggle" variation="warning" class="qa-otp-box-banner mt-24">
      <BlTextListMv>
        <BlTextAv variation="caption-12" tag="li">Kode hanya akan dikirim <b>ke no. HP yang terdaftar di Kartu Prakerja</b> kamu. Transaksi tidak bisa diproses jika kode verifikasi salah.</BlTextAv>
        <BlTextAv variation="caption-12" tag="li">Jika keluar dari halaman ini tanpa isi kode, kamu perlu tunggu <b>15 menit</b> untuk verifikasi lagi. Setelah 3 kali, maka kamu perlu menunggu <b>1 jam.</b></BlTextAv>
        <BlTextAv variation="caption-12" tag="li">Jika <b>3 kali salah</b> memasukkan kode verifikasi, maka kamu perlu menunggu <b>24 jam</b> untuk verifikasi lagi.</BlTextAv>
        <BlTextAv variation="caption-12" tag="li"><b>Jangan kasih kode kamu</b> ke siapa pun termasuk pihak yang mengaku dari Bukalapak.</BlTextAv>
      </BlTextListMv>
    </BlBannerMv>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {BlCodeInputMv} from '@bukalapak/bazaar-guild-mweb';
import {BlBannerMv, BlTextListMv, BlTextAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaOtpBox',
  components: {
    BlCodeInputMv,
    BlBannerMv,
    BlTextListMv,
    BlTextAv
  },
  props: {
    isError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['getRetryOtpToggle']),
    otpInputClass() {
      let otpClass = "otp-code-input grid grid-cols-6 gap-x-3 justify-between";
      if(this.isError) return `${otpClass} error`;

      return otpClass;
    },
    isOtpError() {
      return this.isError && this.getRetryOtpToggle;
    }
  },
  data: () => ({
    otp: ''
  }),
  watch: {
    otp(val) {
      if (val.trim().length === 6) {
        this.$emit('onRetrievePayload', val);
      }
    },
  }
};
</script>

<style lang="scss">
.otp-code-input {
  .bl-textfield__inner {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }
}

.otp-code-input.error {
  .bl-textfield {
    border-color: #EC0C0C !important;
  }
}
</style>
